import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { registerUser } from "../../services/authService";

import { useTipoDocumento } from "../../hooks_cache/useTipoDocumento";
import useModalProgreso from "../../components/hooks/useModalProgreso";

const Register = () => {
  const { data: tipoDocumento } = useTipoDocumento();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
    id_tipoDocumento: "",
    numDocument: "",
    acceptedTerms: false,
  });

  const { start, stop } = useModalProgreso({
    modalTitle: "Registrando nuevo usuario...",
  });

  useEffect(() => {
    return () => {
      stop();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.email !== formData.confirmEmail) {
      alert("Los correos electrónicos no coinciden.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      alert("Las contraseñas no coinciden.");
      return;
    }

    if (!formData.acceptedTerms) {
      alert("Debes aceptar los términos y condiciones para registrarte.");
      return;
    }

    start();
    const payload = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      id_tipoDocumento: formData.id_tipoDocumento,
      numDocument: formData.numDocument,
    };

    try {
      const data = await registerUser(payload);
      console.log(data);
      stop();

      //   navigate("/login");
    } catch (error) {
      stop();
      console.error(error);
    }
  };

  return (
    <div className="register register-with-news-feed">
      <div className="news-feed">
        <div className="news-image" style={{ backgroundImage: "url(/assets/img/login-bg/login-bg-17.jpg)" }}></div>
        <div className="news-caption">
          <h4 className="caption-title">
            <b>Mambo</b>Admin
          </h4>
          <p>
            Tu sistema inteligente para emitir facturas, llevar control y hacer crecer tu negocio, todo de forma fácil y en un solo lugar.
          </p>
        </div>
      </div>
      <div className="register-container">
        <div className="register-header mb-25px h1">
          <div className="mb-1">Registrarse</div>
          <small className="d-block fs-15px lh-16">Crea tu cuenta en MamboAdmin</small>
        </div>
        <div className="register-content">
          <form onSubmit={handleSubmit} className="fs-13px">
            <div className="mb-3">
              <label className="mb-2">
                Nombre <span className="text-danger">*</span>
              </label>
              <div className="row gx-3">
                <div className="col-md-12 mb-2 mb-md-0">
                  <input
                    type="text"
                    required
                    className="form-control fs-13px"
                    placeholder="Nombre"
                    value={formData.name}
                    name="name"
                    onChange={handleChange}
                    onInvalid={(e) => e.target.setCustomValidity("Por favor, ingresa tu nombre.")}
                    onInput={(e) => e.target.setCustomValidity("")}
                  />
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="mb-2">
                Tipo de Documento: <span className="text-danger">*</span>
              </label>
              <div className="row gx-3">
                <div className="col-md-12 mb-2 mb-md-0">
                  <select
                    id="id_tipoDocumento"
                    name="id_tipoDocumento"
                    className="form-select"
                    required
                    onInvalid={(e) => e.target.setCustomValidity("Por favor, selecciona un tipo de documento.")}
                    onInput={(e) => e.target.setCustomValidity("")}
                    defaultValue={formData.id_tipoDocumento}
                    onChange={handleChange}
                  >
                    <option value="">Seleccione un tipo</option>
                    {tipoDocumento?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.descripcion}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className="mb-3">
              <label className="mb-2">
                Documento: <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="numDocument"
                value={formData.numDocument}
                onChange={handleChange}
                className="form-control fs-13px"
                placeholder="Dirección de correo electrónico"
              />
            </div>

            <div className="mb-3">
              <label className="mb-2">
                Correo Electrónico <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control fs-13px"
                placeholder="Dirección de correo electrónico"
              />
            </div>
            <div className="mb-3">
              <label className="mb-2">
                Reingresa Correo Electrónico <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="confirmEmail"
                value={formData.confirmEmail}
                onChange={handleChange}
                className="form-control fs-13px"
                placeholder="Reingresa dirección de correo electrónico"
              />
            </div>
            <div className="mb-4">
              <label className="mb-2">
                Contraseña <span className="text-danger">*</span>
              </label>

              <div className="row gx-3">
                <div className="col-md-6 mb-2 mb-md-0">
                  <input
                    type="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    className="form-control fs-13px"
                    placeholder="Contraseña"
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="password"
                    name="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    className="form-control fs-13px"
                    placeholder="Confirmar contraseña"
                  />
                </div>
              </div>
            </div>

            <div className="form-check mb-4">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreementCheckbox"
                name="acceptedTerms"
                checked={formData.acceptedTerms}
                onChange={handleChange}
                required
                onInvalid={(e) => e.target.setCustomValidity("Debes aceptar los términos para continuar.")}
                onInput={(e) => e.target.setCustomValidity("")}
              />

              <label className="form-check-label" htmlFor="agreementCheckbox">
                Al hacer clic en Registrarse, aceptas nuestros <Link to="/terms">Términos</Link> y confirmas que has leído nuestra{" "}
                <Link to="/privacy">Política de Datos</Link>.
              </label>
            </div>
            <div className="mb-4">
              <button type="submit" className="btn btn-theme d-block w-100 btn-lg h-45px fs-13px">
                Registrarse
              </button>
            </div>
            <div className="mb-4 pb-5">
              ¿Ya eres miembro? Haz clic <Link to="/login">aquí</Link> para iniciar sesión.
            </div>
            <hr className="bg-gray-600 opacity-2" />
            <p className="text-center text-gray-600">&copy; MamboAdmin Todos los Derechos Reservados 2025</p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Register;
